<template>
  <div>
    <div class="flex flex-wrap gap-3 items-end mb-3">
      <div class="flex flex-col">
        <label class="mb-1 text-sm font-medium text-gray-700"
          >Select Mobile to WhatsApp invoice</label
        >
        <select
          id="mobileSelect"
          v-model="selectedMobile"
          class="px-4 py-2 bg-white rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option
            v-for="(item, index) in userMobiles"
            :key="index"
            :value="item.value"
            :label="item.label + ' : ' + item.value"
          >
            {{ item.label }} : {{ item.value }}
          </option>
          <option value="">Enter Manually</option>
        </select>
      </div>
      <input
        v-model="selectedMobile"
        type="text"
        placeholder="Or enter phone here"
        class="px-4 py-2 rounded border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
      <button
        @click="handleSendWhatsappVendorInvoice()"
        class="px-6 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <span>Send to Whatsapp</span>
        <span v-if="isWhatsappLoader" class="ml-2">
          <i class="fas fa-spinner fa-spin" />
        </span>
      </button>
      <button
        @click="handlePrint()"
        class="px-6 py-2 text-white bg-gray-600 rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
      >
        <i class="mr-2 fas fa-print" />
        <span>Print</span>
      </button>
    </div>

    <div class="p-3 bg-slate-100">
      <div ref="printArea" class="rajdoot-bill mx-auto bg-white shadow-md">
        <!-- Vendor firm header -->
        <div class="bill-header">
          <img
            class="vendor-mark"
            src="../../assets/images/invoice/vendor-logo-mark.png"
            alt=""
          />
          <div class="firm-name-box">
            {{ displayFirmName }}
          </div>
        </div>

        <!-- Meta row -->
        <div class="meta-grid">
          <div class="meta-left">
            <div class="meta-line">
              <span class="meta-label">M/S.</span>
              <span class="meta-value capitalize">{{ data.customer.name }}</span>
            </div>
            <div class="meta-line">
              <span class="meta-label">Phone No.:</span>
              <span class="meta-value">{{ data.customer.phone }}</span>
            </div>
          </div>
          <div class="meta-right">
            <div class="meta-line">
              <span class="meta-label">Invoice No. :</span>
              <span class="meta-value">{{ data.invoiceNumber }}</span>
            </div>
            <div class="meta-line">
              <span class="meta-label">DATE :</span>
              <span class="meta-value">{{ data.invoiceDate | convertDate }}</span>
            </div>
            <div class="meta-line">
              <span class="meta-label">Job No. :</span>
              <span class="meta-value">{{
                data.serviceRequestNumber || "—"
              }}</span>
            </div>
          </div>
        </div>

        <div class="header-rule"></div>

        <!-- Items -->
        <table class="items-table">
          <thead>
            <tr>
              <th class="col-sr">Sr. No.</th>
              <th class="col-desc">Description</th>
              <th class="col-qty">Qty.</th>
              <th class="col-rate">Rate</th>
              <th class="col-amt">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in data.labors" :key="index">
              <td class="col-sr text-center">{{ index + 1 }}</td>
              <td class="col-desc">{{ item.description }}</td>
              <td class="col-qty text-center">{{ item.quantity }}</td>
              <td class="col-rate text-right">{{ item.laborCost | currency }}</td>
              <td class="col-amt text-right">
                {{
                  (item.laborCost * item.quantity - (item.discount || 0))
                    | currency
                }}
              </td>
            </tr>
            <tr
              v-for="n in Math.max(0, 8 - (data.labors || []).length)"
              :key="'empty-' + n"
              class="empty-row"
            >
              <td>&nbsp;</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>

        <div class="totals-row">
          <div class="words">
            <div class="words-label">Rs. In Words</div>
            <div class="words-value">{{ amountInWords }}</div>
          </div>
          <div class="total-box">
            <span>Total</span>
            <strong>{{ total | currency }}</strong>
          </div>
        </div>

        <div class="terms-row">
          <div class="terms">
            <div>* Subject to Pune Jurisdiction.</div>
            <div>Received goods in good &amp; working condition.</div>
          </div>
          <div class="signatory">Authorised Signatory</div>
        </div>

        <!-- Associate with Rajdoot -->
        <div class="associate-rule">
          <span>ASSOCIATE WITH</span>
        </div>

        <div class="rajdoot-brand">
          <img
            class="rajdoot-logo"
            src="../../assets/images/rajdoot.png"
            alt="Rajdoot Services"
          />
          <div class="tagline">Rajdoot Ko Call, Problem Solve</div>
          <div class="address">
            Address : Loksangam Vihar, 'P' Building, Shop No. 13, Near D P Road,
            Opp. SVC Co-Oprative Bank, Aundh, Pune - 411 007. | Ph.: 8237478645
            | Cell : 8237478647 | 020-25884004
          </div>
        </div>

        <div class="service-icons">
          <img
            src="../../assets/images/invoice/service-icon-electrician.png"
            alt=""
          />
          <img src="../../assets/images/invoice/service-icon-mixer.png" alt="" />
          <img
            src="../../assets/images/invoice/service-icon-microwave.png"
            alt=""
          />
          <img src="../../assets/images/invoice/service-icon-fan.png" alt="" />
          <img src="../../assets/images/invoice/service-icon-pump.png" alt="" />
        </div>

        <div class="bottom-bar">
          Electrical Maintenance | Home Appliances Repairs | Water Pump Repairs
          | Motor Rewinding
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { apiHelper } from "../../utils/helpers";
import endpoints from "@/utils/constants";
import { printElementAsA4 } from "@/utils/printA4";
import { mapGetters } from "vuex";

const ONES = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen"
];
const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety"
];

function twoDigits(n) {
  if (n < 20) return ONES[n];
  return `${TENS[Math.floor(n / 10)]}${n % 10 ? " " + ONES[n % 10] : ""}`.trim();
}

function numberToIndianWords(num) {
  const n = Math.round(Math.abs(Number(num) || 0));
  if (n === 0) return "Zero Rupees Only";
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const hundred = Math.floor((n % 1000) / 100);
  const rest = n % 100;
  const parts = [];
  if (crore) parts.push(`${twoDigits(crore)} Crore`);
  if (lakh) parts.push(`${twoDigits(lakh)} Lakh`);
  if (thousand) parts.push(`${twoDigits(thousand)} Thousand`);
  if (hundred) parts.push(`${ONES[hundred]} Hundred`);
  if (rest) parts.push(twoDigits(rest));
  return `${parts.join(" ")} Rupees Only`;
}

export default {
  data() {
    return {
      isWhatsappLoader: false,
      userMobiles: [],
      selectedMobile: null
    };
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    },
    convertDate(date) {
      if (!date) return "—";
      try {
        return format(date, "DD MMM YYYY");
      } catch (e) {
        return String(date);
      }
    }
  },
  computed: {
    ...mapGetters({
      data: "vendor/getInvoiceData"
    }),
    displayFirmName() {
      const vendor = (this.data && this.data.vendor) || {};
      const firmName = (
        vendor.firmName ||
        vendor.firm_name ||
        ""
      )
        .toString()
        .trim();
      if (firmName) {
        return firmName;
      }
      // Same fallback as voucher list:
      // firm_name OR "first_name last_name"
      const fullName = (
        vendor.name ||
        `${vendor.firstName || ""} ${vendor.lastName || ""}` ||
        ""
      )
        .toString()
        .trim();
      return fullName || "Vendor";
    },
    total() {
      const labors = (this.data && this.data.labors) || [];
      return labors.reduce(
        (a, b) => a + b.laborCost * b.quantity - (b.discount || 0),
        0
      );
    },
    amountInWords() {
      return numberToIndianWords(this.total);
    }
  },
  mounted() {
    this.getUserMobiles();
  },
  methods: {
    fetchData() {
      this.getUserMobiles();
    },
    resetProperty() {
      this.userMobiles = null;
      this.selectedMobile = null;
    },
    handlePrint() {
      printElementAsA4(this.$refs.printArea, { title: "Vendor Invoice" });
    },
    getUserMobiles() {
      if (this.data && this.data.userId) {
        apiHelper
          .call(
            "get",
            `${endpoints.LARAVEL_BASE_URL}/api/v1/users/${this.data.userId}/mobiles`
          )
          .then(response => {
            this.userMobiles = response.data.mobiles;
          })
          .catch(() => {
            this.$notify({
              message: "Something went wrong",
              type: "danger",
              title: "Error"
            });
          });
      }
    },
    handleSendWhatsappVendorInvoice() {
      this.isWhatsappLoader = true;
      apiHelper
        .call(
          "post",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/send/vendor-invoice/${this.data.serviceRequestId}`,
          { phone: this.selectedMobile }
        )
        .then(() => {
          this.isWhatsappLoader = false;
          this.userMobiles = [];
          this.selectedMobile = null;
          this.$notify({
            message: "Invoice sent to whtasapp",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.isWhatsappLoader = false;
          this.$notify({
            message: "Something went wrong",
            type: "danger",
            title: "Error"
          });
        });
    }
  }
};
</script>

<style scoped>
.rajdoot-bill {
  --bill-blue: #005696;
  max-width: 760px;
  padding: 18px 18px 0;
  color: #111;
  font-family: Arial, Helvetica, sans-serif;
  border: 1px solid #dbe3ea;
}

.bill-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.vendor-mark {
  width: 72px;
  height: 72px;
  object-fit: contain;
  flex-shrink: 0;
}

.firm-name-box {
  flex: 1;
  border: 1.5px solid var(--bill-blue);
  color: var(--bill-blue);
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-align: center;
  text-transform: uppercase;
  padding: 10px 12px;
  line-height: 1.2;
}

.meta-grid {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 8px;
  font-size: 13px;
}

.meta-line {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}

.meta-label {
  font-weight: 700;
  white-space: nowrap;
}

.meta-value {
  border-bottom: 1px solid #999;
  min-width: 140px;
  flex: 1;
}

.meta-right {
  text-align: left;
  min-width: 220px;
}

.header-rule {
  height: 3px;
  background: var(--bill-blue);
  margin: 8px 0 0;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
}

.items-table th,
.items-table td {
  border: 1px solid #222;
  padding: 6px 8px;
  vertical-align: top;
}

.items-table th {
  background: #f3f6f9;
  font-weight: 700;
  text-align: center;
}

.col-sr {
  width: 10%;
}
.col-desc {
  width: 46%;
}
.col-qty {
  width: 12%;
}
.col-rate {
  width: 16%;
}
.col-amt {
  width: 16%;
}

.empty-row td {
  height: 28px;
}

.totals-row {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 10px;
  align-items: stretch;
}

.words {
  flex: 1;
  font-size: 12px;
}

.words-label {
  font-weight: 700;
  margin-bottom: 4px;
}

.words-value {
  border-bottom: 1px solid #999;
  min-height: 22px;
  padding-bottom: 2px;
  text-transform: capitalize;
}

.total-box {
  min-width: 180px;
  border: 1px solid #222;
  padding: 8px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.terms-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 14px;
  font-size: 11px;
}

.signatory {
  border-top: 1px solid #222;
  padding-top: 4px;
  min-width: 160px;
  text-align: center;
}

.associate-rule {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 18px 0 10px;
  color: var(--bill-blue);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.associate-rule::before,
.associate-rule::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--bill-blue);
}

.associate-rule span {
  white-space: nowrap;
}

.rajdoot-brand {
  text-align: center;
}

.rajdoot-logo {
  width: 260px;
  max-width: 70%;
  margin: 0 auto;
  display: block;
}

.tagline {
  color: var(--bill-blue);
  font-style: italic;
  font-size: 14px;
  margin-top: 4px;
}

.address {
  font-size: 11px;
  color: #333;
  margin-top: 6px;
  line-height: 1.4;
}

.service-icons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 8px;
  margin: 14px 0 10px;
}

.service-icons img {
  width: 56px;
  height: 56px;
  object-fit: contain;
}

.bottom-bar {
  margin: 0 -18px;
  background: var(--bill-blue);
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 600;
  padding: 8px 10px;
}
</style>
